module.exports = __webpack_public_path__ + "img/andres-alcantara.f8db0e01.png";